import React, { useEffect, useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import "./Dashboard.css";
import Form from "react-bootstrap/Form";
import uploadIcon from "../../images/upload-icon.svg";
import Button from "react-bootstrap/Button";
import { FaSquare } from "react-icons/fa";
import { FiSearch, FiSliders } from "react-icons/fi";
import { useSelector } from "react-redux";
import { getPatients } from "../services/patientService";
import { toast } from "react-toastify";
import CustomPagination from "../../Common/Component/CustomPagination/CustomPagination";
import Modal from "react-bootstrap/Modal";
import reddelete from "../../images/red-Delete.svg";
import { useNavigate } from "react-router-dom";
import { requestPermissionAndGetToken } from "../../services/pushNotificationService";
function DashboardComponent() {
  const data = useSelector((state) => state.login?.data);
  const navigate = useNavigate();
  const [selectedFile, setSelectedFile] = useState(null);
  const [patients, setPatients] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(false);

  const colors = [
    "#66D4CF", // Mint
    // "#FFD60A", //  Yellow
    "#40C8E0", // Teal
    // "#BF5AF2", // Purple
    "#64D2FF", // Cyan
    "#E9E976", //   light yellow
    // "#5E5CE6", // Indigo
    "#e9c183", // light Orange
  ];

  const getColorForScore = (score) => {
    if (score >= 0 && score <= 3) {
      return "#BDE7BD"; // Light Green
    } else if (score >= 4 && score <= 6) {
      return "#FFF8B8"; // Pale Yellow
    } else if (score >= 7 && score <= 10) {
      return "#FFB6B3"; // Light Coral Pink
    } else {
      return "#BDE7BD"; // Default Grey for invalid scores
    }
  };

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  /* Function's */
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setLimit(parseInt(event.target.value, 10));
    setPage(0);
  };

  const [modalShow, setModalShow] = React.useState(false);

  useEffect(() => {
    fetchPatients(selectedValue);
  }, [page, limit]);

  useEffect(() => {
    // Request permission and get token when the app loads
    requestPermissionAndGetToken();
  }, []);

  const fetchPatients = async (eventKey, query = null) => {
    setLoading(true);
    try {
      const response = await getPatients({
        page: page + 1,
        limit,
        searchKey: query?.length == 0 ? "" : searchText,
        sortBy: eventKey,
      });
      if (response?.status === "SUCCESS") {
        setPatients(response?.data?.list);
        setTotalPages(response?.data?.totalPages || 0);
        setTotalItems(response?.data?.totalItems || 0);
      }
    } catch (error) {
      toast.error("Please try again later");
    } finally {
      setLoading(false);
    }
  };

  const [selectedValue, setSelectedValue] = useState("high-icbps");

  const handleSelect = (eventKey) => {
    setSelectedValue(eventKey); // Update the state with the selected value
    fetchPatients(eventKey);
  };

  const redirectToProfile = (provider) => {
    data.role === "DOCTOR" &&
      navigate("/doctor/patient", { state: { patient: provider } });
    data.role === "ADMIN" &&
      navigate("/admin/patient", { state: { patient: provider } });
  };

  const handleSearchChange = (e) => {
    const query = e.target.value || "";
    setSearchText(query);
    if (query.length === 0) {
      fetchPatients(selectedValue, query);
    }
  };

  const handelSearchSubmit = async () => {
    await fetchPatients(selectedValue);
  };

  return (
    <div className="Dashboard-wrapper patient-dashboard">
      <div className="dashboard-inner-wrapper">
          <div className="Dashboard-lft-blk" aria-busy={loading}>
            <div className="lft-blk-top d-flex justify-content-between mb-3">
              <h2>Patient Listing</h2>
            </div>

            <div className="add-doctor">
              <Form>
                <Form.Group controlId="searchInput" className="patient-search-field">
                  <Form.Control
                    type="search"
                    aria-label="Search"
                    value={searchText}
                    onChange={handleSearchChange}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault(); // prevent form submission/reload
                        if (!loading) handelSearchSubmit();
                      }
                    }}
                    placeholder="Search by exact name or email..."
                  />
                </Form.Group>
              </Form>
              <Button
                onClick={() => handelSearchSubmit()}
                className="filled-btn patient-search-button"
                disabled={loading}
              >
                Search
                {loading && <span className="spinner-border spinner-border-sm patient-search-spinner" aria-hidden="true" />}
              </Button>

              <Dropdown
                className="patient-info-dropdown Patient-info-dropdown-custom"
                onSelect={handleSelect}
              >
                <Dropdown.Toggle className="db-dropdown h-100" disabled={loading}>
                  <FiSliders aria-hidden="true" />
                  {selectedValue === ""
                    ? "Sort By"
                    : selectedValue === "high-icbps"
                    ? "High ICBPS"
                    : "Recently Added"}
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item eventKey="Default">Recent</Dropdown.Item>
                  <Dropdown.Item eventKey="high-icbps">
                    High ICBPS
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>

            {/* 
To display color codes dynamically based on the ICBPS (Interstitial Cystitis Bladder Pain Score) range (0–10), you can define ranges and map them to specific colors. For example:
Suggested Score Ranges and Colors:

    0–3: Light Green (#BDE7BD) - Indicates lower pain levels.
    4–6: Pale Yellow (#FFF8B8) - Indicates moderate pain levels.
    7–10: Light Coral Pink (#FFB6B3) - Indicates higher pain levels. */}

            <div
              className="table-responsive dashboard-table"
              role="region"
              aria-label="Scrollable patient listing"
              tabIndex="0"
            >
              <table className="patients-table" aria-label="Patient listing">
                <colgroup>
                  <col className="patient-score-column" />
                  <col className="patient-name-column" />
                  <col className="patient-icbps-column" />
                  <col className="patient-gender-column" />
                  <col className="patient-phone-column" />
                  <col className="patient-email-column" />
                </colgroup>
                <thead>
                  <tr className="t-row-block">
                    <th scope="col"><span className="visually-hidden">Score indicator</span></th>
                    <th scope="col">Patient Name</th>
                    <th scope="col">ICBPS</th>
                    <th scope="col">Gender</th>
                    <th scope="col">Mobile Number</th>
                    <th scope="col">Email</th>
                  </tr>
                </thead>
                <tbody>
                  {patients.length > 0 ? (
                    patients.map((patient, index) => (
                      <tr
                        key={patient.id || index}
                        className="patient-row"
                        onClick={() => redirectToProfile(patient)}
                      >
                        <td scope="row" className="score-cell">
                          <FaSquare
                            className="score-box"
                            style={{
                              color: getColorForScore(patient?.icbps),
                            }}
                          />
                        </td>
                        <td>
                          <button
                            type="button"
                            className="patient-profile-link"
                            onClick={(e) => {
                              e.stopPropagation();
                              redirectToProfile(patient);
                            }}
                          >
                            <div className="patientlist-img">
                              {patient?.photoUrl ? (
                                <img src={patient.photoUrl} alt="patient-img" />
                              ) : (
                                <div
                                  className="patient-initials"
                                  style={{
                                    background: colors[index % colors.length],
                                  }}
                                >
                                  {`${patient?.firstName?.[0] || ""}${
                                    patient?.lastName?.[0] || ""
                                  }`.toUpperCase()}
                                </div>
                              )}
                            </div>
                            <span
                              className="text-capitalize "
                              style={{ cursor: "pointer" }}
                            >
                              {patient?.firstName ? patient?.firstName : "-"}{" "}
                              {patient?.lastName ? patient?.lastName : ""}
                            </span>
                          </button>
                        </td>

                        <td>
                          <span className="patient-score-badge" style={{ backgroundColor: getColorForScore(patient?.icbps) }}>
                            {patient?.icbps !== undefined ? patient.icbps : "-"}
                          </span>
                        </td>
                        <td>{patient?.gender ? patient.gender : "-"}</td>
                        <td>{patient?.phone ? patient.phone : "-"}</td>
                        <td>{patient?.email ? patient.email : "-"}</td>
                      </tr>
                    ))
                  ) : loading ? (
                    <tr aria-hidden="true"><td colSpan="6" className="patient-empty-state" /></tr>
                  ) : (
                    <tr>
                      <td colSpan="6" className="text-center patient-empty-state">
                        <span className="patient-empty-content">
                          <FiSearch aria-hidden="true" />
                          <strong>No Patients Found</strong>
                        </span>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <div className="pagination-blk">
              <CustomPagination
                totalItems={totalItems}
                page={page}
                onPageChange={handleChangePage}
                limit={limit}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </div>
          </div>
      </div>

      {/* doctor-page */}
      <div className="dashboard-insights d-none">
        <div className="doctor-box">
          <div className="image-upload">
            <div className="photo-upload-container">
              <label htmlFor="file-upload" className="file-upload-label">
                <img src={uploadIcon} alt="Upload" className="upload-icon" />
              </label>
              <input
                id="file-upload"
                type="file"
                onChange={handleFileChange}
                className="file-upload-input"
              />
            </div>
          </div>
          <Form className="form-block">
            <div className="forms-box">
              <div className="form-control-area">
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlInputFirstName"
                >
                  <Form.Label className="details">
                    First Name<span className="asterisk">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter first name"
                    required
                  />
                </Form.Group>
              </div>

              <div className="form-control-area">
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlInputLastName"
                >
                  <Form.Label className="details">
                    Last Name<span className="asterisk">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter last name"
                    required
                  />
                </Form.Group>
              </div>

              <div className="form-control-area">
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlInputMobile"
                >
                  <Form.Label className="details">
                    Mobile Number<span className="asterisk">*</span>
                  </Form.Label>
                  <Form.Control type="tel" placeholder="+966" required />
                </Form.Group>
              </div>

              <div className="form-control-area">
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlInputEmail"
                >
                  <Form.Label className="details">
                    Email<span className="asterisk">*</span>
                  </Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="name@example.com"
                    required
                  />
                </Form.Group>
              </div>

              <div className="form-control-area">
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlSelectGender"
                >
                  <Form.Label className="details">Gender</Form.Label>
                  <Form.Select className="selected-fields">
                    <option>Select Gender</option>
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                    <option value="other">Other</option>
                  </Form.Select>
                </Form.Group>
              </div>
              <div className="form-control-area">
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlInputDOB"
                >
                  <Form.Label className="details">Date of Birth</Form.Label>
                  <Form.Control
                    type="date"
                    placeholder="Select date of birth"
                  />
                </Form.Group>
              </div>
              <div className="form-control-area">
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlSelectNationality"
                >
                  <Form.Label className="details">Nationality</Form.Label>
                  <Form.Select className="selected-fields">
                    <option>Select Nationality</option>
                    <option value="saudi">Saudi Arabia</option>
                    <option value="other">Other</option>
                  </Form.Select>
                </Form.Group>
              </div>
              <div className="form-control-area">
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlSelectMaritalStatus"
                >
                  <Form.Label className="details">Marital Status</Form.Label>
                  <Form.Select className="selected-fields">
                    <option>Select Marital Status</option>
                    <option value="single">Single</option>
                    <option value="married">Married</option>
                    <option value="divorced">Divorced</option>
                    <option value="widowed">Widowed</option>
                  </Form.Select>
                </Form.Group>
              </div>
              <div className="form-control-area">
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlSelectBloodGroup"
                >
                  <Form.Label className="details">Blood Group</Form.Label>
                  <Form.Select className="selected-fields">
                    <option>Select Blood Group</option>
                    <option value="a+">A+</option>
                    <option value="a-">A-</option>
                    <option value="b+">B+</option>
                    <option value="b-">B-</option>
                    <option value="o+">O+</option>
                    <option value="o-">O-</option>
                    <option value="ab+">AB+</option>
                    <option value="ab-">AB-</option>
                  </Form.Select>
                </Form.Group>
              </div>
              <div className="form-control-area">
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlTextareaAddress"
                >
                  <Form.Label className="details">Address</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    placeholder="Enter your address"
                  />
                </Form.Group>
              </div>
            </div>
            <h6 className="form-title">Emergency Contact:</h6>
            <div className="forms-boxx">
              <div className="form-control-area">
                <Form.Group
                  className="mb-3"
                  controlId="exampleFormm.ControlInputFirstName"
                >
                  <Form.Label className="details">First Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter first name"
                    required
                  />
                </Form.Group>
              </div>

              <div className="form-control-area">
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlSelectRelationship"
                >
                  <Form.Label className="details">Relationship</Form.Label>
                  <Form.Select className="select-relation-field">
                    <option>Select Relationship</option>
                    <option value="parent">Parent</option>
                    <option value="spouse">Spouse</option>
                    <option value="sibling">Sibling</option>
                    <option value="friend">Friend</option>
                    <option value="other">Other</option>
                  </Form.Select>
                </Form.Group>
              </div>
              <div className="form-control-area">
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlInputEmergencyPhone"
                >
                  <Form.Label className="details">Phone no.</Form.Label>
                  <Form.Control type="tel" placeholder="Enter phone number" />
                </Form.Group>
              </div>
            </div>
          </Form>
        </div>
        <div className="button-block">
          <Button className="outlined-btn">Cancel</Button>
          <Button className="filled-btn">Save</Button>
        </div>
      </div>

      {/* delete patient modal */}
      <Modal
        className="dlt-patient-modal"
        show={modalShow}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => setModalShow(false)}
      >
        <Modal.Body>
          <div className="d-flex justify-content-center mb-3">
            <div className="delete-img">
              <img src={reddelete} alt="img"></img>
            </div>
          </div>
          <h4>Are you sure? </h4>
          <p>You want to detele this patient</p>
          <div className="authentication-btns d-flex justify-content-center gap-4">
            <Button className="btn border-btn btn-no outlined-btn">No</Button>
            <Button className="btn dark-btn btn-yes">Yes</Button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}
export default DashboardComponent;
